var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { CFBaseModalVeilTokens } from '@connectrn/ds-ui-base';
import { commonAttrs } from '../../utils';
import { CFModalContainerElements } from './ModalContainer.styles';
import { CFModalVeil } from './ModalVeil';
export const CFModalContainer = (_a) => {
    var { alternateTheme, children, onDismiss, veilVisible } = _a, rest = __rest(_a, ["alternateTheme", "children", "onDismiss", "veilVisible"]);
    const [veilPresent, setVeilPresent] = useState(false);
    const [modalsPresent, setModalsPresent] = useState(false);
    const { Root } = CFModalContainerElements;
    const onClickVeil = () => {
        if (onDismiss)
            onDismiss();
    };
    useEffect(() => {
        if (children) {
            setVeilPresent(true);
            setModalsPresent(true);
        }
        else {
            // Delay exit animation
            if (modalsPresent) {
                setVeilPresent(false);
                setTimeout(() => setModalsPresent(false), CFBaseModalVeilTokens.TRANSITION_DURATION);
            }
        }
    }, [children]);
    return (React.createElement(Root, Object.assign({ active: modalsPresent }, commonAttrs(rest)),
        React.createElement(CFModalVeil, { active: veilPresent, alternateTheme: alternateTheme, onClick: onClickVeil, visible: veilVisible }),
        children));
};
